/**
 * Single source of truth for DataTable tree-mode geometry.
 *
 * Both the desktop leading cell (<TreeCellLeading>) and the mobile summary
 * cell (<MobileSummaryCell>) must indent identically or the row-2 content
 * drifts out of alignment with the row-1 title. Keep every pixel value here
 * so the two render paths can never disagree.
 */

/** Horizontal indent added per tree depth level. */
export const TREE_INDENT_PER_LEVEL_PX = 16;

/** Chevron button box (size-4). */
const TREE_CHEVRON_PX = 16;
/** Row-type icon box (size-3.5). */
const TREE_ICON_PX = 14;
/** Flex `gap-1` seam between leading children. */
const TREE_GAP_PX = 4;

/**
 * Width of the leading prefix (chevron [+ icon]) that precedes the label in
 * <TreeCellLeading>. The mobile summary cell adds this to row-2's left pad so
 * its content lines up with the row-1 title rather than the card edge.
 *
 * Layout is `flex gap-1` over [chevron, icon?, label]:
 *   chevron + gap (+ icon + gap when an icon is present).
 */
export function treeLeadingPrefixPx(hasIcon: boolean): number {
  return (
    TREE_CHEVRON_PX + TREE_GAP_PX + (hasIcon ? TREE_ICON_PX + TREE_GAP_PX : 0)
  );
}
